// extracted by mini-css-extract-plugin
export var cardIcon = "_z-5";
export var cardIconUnframed = "_z-9";
export var checkboxCard = "_z-0";
export var checkboxCardSelected = "_z-4";
export var disabled = "_z-2";
export var interactive = "_z-1";
export var outerBorder = "_z-3";
export var spacerMedium = "_z-8";
export var spacerSmall = "_z-7";
export var spacerXsmall = "_z-6";